// extracted by mini-css-extract-plugin
export var standaloneTable = "_fr-0";
export var standaloneTableWithBodyFill = "_fr-1";
export var withExtraHeader = "_fr-2";